/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { globalBreak } from '@/styles/break';
import { SxProps } from '@mui/material';

export const breadcrumbTrailContainerSX: SxProps = {
	'&:first-of-type': {
		mt: 0,
		pb:globalBreak({mobile:1,desktop:0})
	},
	'& ol li a':{
		textDecoration:'none',
	}
};

export const breadcrumbTrailContainerMobSX:SxProps = {
	maxWidth: '98%',
	overflowX: 'scroll',
	WebkitOverflowScrolling: 'touch',
	pb:1,
	marginBottom:'-15px',
	'& li': {
		display: 'table-cell',
		px:1,
		verticalAlign:'middle'
	},'& li:first-of-type': {
		pl:0,
	},
	'& ol': {
		padding: 0,
		display: 'table',
	},
	'& nav': {
		width: '300px',
		overflowX: 'scroll',
		WebkitOverflowScrolling: 'touch',
	},
	'&::-webkit-scrollbar': {
		display:'none'
	},
	'& li > a, li > span': {
		whiteSpace: 'nowrap',
	},
	'& li svg':{
		mt:0.8
	}
}

export const scrollRightBtnSx:SxProps = {
	position:'absolute', 
	top:0,
	right:-12,
	'& > svg':{
		fontSize:30
	}
}
